import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  LayoutDashboard, User, FileText, MessageSquare, TrendingUp, Route, Briefcase,
  Sparkles, Crown, Award, Trophy, Users, Mic, Handshake, Bell, PiggyBank,
  Settings as SettingsIcon, Gift, Shield, Globe, Compass,
} from "lucide-react";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem,
} from "@/components/ui/command";

const items = [
  { group: "Overview", items: [
    { label: "Dashboard", to: "/app", icon: LayoutDashboard, keywords: "home stats metrics" },
    { label: "AI Insights", to: "/app/insights", icon: Sparkles, keywords: "insights ai daily briefing" },
    { label: "Achievements", to: "/app/achievements", icon: Trophy, keywords: "xp badges level" },
  ]},
  { group: "Growth", items: [
    { label: "Career Advisor Chat", to: "/app/chat", icon: MessageSquare, keywords: "chat coach ai advisor" },
    { label: "Career Roadmap", to: "/app/roadmap", icon: Route, keywords: "path progression steps" },
    { label: "Salary Intelligence", to: "/app/salary", icon: TrendingUp, keywords: "salary market pay comparison" },
    { label: "Personality Assessments", to: "/app/assessments", icon: Compass, keywords: "big5 riasec holland mbti aptitude personality" },
    { label: "Executive Coaching", to: "/app/executive", icon: Crown, keywords: "leadership vp cxo director" },
    { label: "Financial Planning", to: "/app/financial", icon: PiggyBank, keywords: "money retirement wealth" },
  ]},
  { group: "Hunt", items: [
    { label: "Jobs", to: "/app/jobs", icon: Briefcase, keywords: "applications tracker kanban" },
    { label: "Network", to: "/app/network", icon: Users, keywords: "contacts recruiters mentors" },
    { label: "Interview Simulator", to: "/app/interview", icon: Mic, keywords: "mock interview practice" },
    { label: "Salary Negotiation", to: "/app/negotiation", icon: Handshake, keywords: "negotiate scripts practice" },
  ]},
  { group: "Assets", items: [
    { label: "Profile", to: "/app/profile", icon: User, keywords: "profile personal experience skills" },
    { label: "Resume AI", to: "/app/resume", icon: FileText, keywords: "resume ats rewrite cover letter" },
    { label: "Portfolio Builder", to: "/app/portfolio", icon: Sparkles, keywords: "portfolio site personal brand" },
    { label: "Certifications", to: "/app/certifications", icon: Award, keywords: "certs pmp aws certifications" },
  ]},
  { group: "Recruit", items: [
    { label: "Recruiter Portal", to: "/app/recruiter", icon: Users, keywords: "hire recruiter post job talent shortlist" },
    { label: "Public Jobs Board", to: "/jobs-board", icon: Briefcase, keywords: "jobs board browse listings" },
  ]},
  { group: "Account", items: [
    { label: "Referrals", to: "/app/referrals", icon: Gift, keywords: "invite friends share credit" },
    { label: "Notifications", to: "/app/notifications", icon: Bell, keywords: "alerts reminders" },
    { label: "Settings", to: "/app/settings", icon: SettingsIcon, keywords: "preferences email theme push" },
    { label: "Public Directory", to: "/directory", icon: Globe, keywords: "browse professionals directory" },
    { label: "Discover pricing", to: "/app/pricing", icon: Compass, keywords: "pro upgrade billing" },
  ]},
];

export default function CommandPalette({ open, setOpen }) {
  const nav = useNavigate();

  useEffect(() => {
    const down = (e) => {
      if ((e.key === "k" && (e.metaKey || e.ctrlKey))) {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, [setOpen]);

  const go = (to) => {
    setOpen(false);
    nav(to);
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Search pages, jobs, skills, actions…" data-testid="command-palette-input" />
      <CommandList data-testid="command-palette-list">
        <CommandEmpty>No results found.</CommandEmpty>
        {items.map((section) => (
          <CommandGroup key={section.group} heading={section.group}>
            {section.items.map((it) => (
              <CommandItem
                key={it.to}
                value={`${it.label} ${it.keywords}`}
                onSelect={() => go(it.to)}
                data-testid={`command-item-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <it.icon size={14} className="mr-2" />
                <span>{it.label}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        ))}
      </CommandList>
    </CommandDialog>
  );
}
